<template>
  <v-app
    :class="[
      'grey lighten-4',
    ]"
    light
    v-resize="onResize"
    v-scroll="onScroll"
  >
    <app-navigation-drawer v-if="isDesktop && pageNavigationDrawer"></app-navigation-drawer>

    <app-toolbar v-if="pageToolbar" @open-dialog="openDialog"></app-toolbar>
    <!-- sticky agreement banner -->
    <div class="sticky-alert" v-if="showAgreementInfo">
       <v-icon dark>warning</v-icon>
      <div class="alert-content" v-on:click="acceptTerm"  v-html="$t('label.updated_agreement', {link: `<a class='update-agreement' href='javascript:;'>${$t('label.here')}</a>`, pdfLink: updatedJforceAgreementPdf})">
      </div>
    </div>

     <v-alert class="login-error" dark type="error" v-model="loginError" :class="{ 'pa-2': isMobile }">
          <div
          class="d-flex"
            @click="clearErrors"
          >  <div
          class="d-flex"
            @click="clearErrors"
          > {{$t('error.title') }} {{$t('error.sub_title')}}</div>
            <v-icon class="btn-close">cancel</v-icon>
          </div>
   </v-alert>
<v-content>
      <div v-if="isSuspended && $route.params.id !== 'suspended-info'" class="router-view">
        <v-alert dark type="error" v-model="warning" :class="{ 'pa-2': isMobile }">
          <div
            @click="redirectTo"
            v-html="$t('label.suspended', {x: ` <a href='javascript:;' class='redirect-link'>${$t('label.click_here')}</a> `,})"
          ></div>
        </v-alert>
      </div>
      <loading-status v-if="loadingPage" status-key="app.loading_page"></loading-status>
      <router-view
        v-else
        class="router-view"
        @open-agreement-dialog="openAgreementDialog"
        @open-dialog="openDialog"
      ></router-view>

      <v-btn
        fixed
        dark
        fab
        bottom
        right
        color="primary"
        :small="isMobile"
        v-if="
          ['team-members-list', 'orders-list', 'sales', 'cms'].includes(
            $route.name
          ) && offsetTop > 400
        "
        @click="topFunction"
        :class="isMobile && pageBottomNavigation ? 'mb-5' : ''"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-content>

    <app-bottom-navigation v-if="isMobile && pageBottomNavigation"></app-bottom-navigation>

    <v-dialog v-if="pageDialog" v-model="dialog" max-width="290">
      <div class="jcard">
        <div class="px-3 pt-3 jcard_dialog--header">
          <div class="jcard_dialog--header--title title">{{ $t(pageDialog.title) }}</div>
          <v-icon @click="dialog = false">close</v-icon>
        </div>
        <div class="pt-3 px-3 jcard_dialog--content" v-html="pageDialog.html"></div>
        <div :class="($vuetify.rtl ? 'jcard_dialog--actions_left' : 'jcard_dialog--actions')">
          <v-btn color="primary" flat="flat" @click="dialog = false">
            {{
            $t("button.close")
            }}
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-if="addToHomeScreenDialog" v-model="addToHomeScreenDialog" max-width="290">
      <div class="jcard">
        <div class="px-3 pt-3 jcard_dialog--header">
          <div class="jcard_dialog--header--title title">{{ $t("add_to_homescreen.title") }}</div>
        </div>
        <div
          class="jcard_dialog--header--description pa-3"
        >{{ $t("add_to_homescreen.description") }}</div>
        <div :class="($vuetify.rtl ? 'jcard_dialog--actions_left' : 'jcard_dialog--actions')">
          <v-btn color="primary" flat="flat" @click="no">
            {{
            $t("button.no")
            }}
          </v-btn>
          <v-btn color="primary" flat="flat" @click="yes">
            {{
            $t("button.yes")
            }}
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <!-- jforce agreement dialog -->
    <v-dialog
      :persistent="persistent"
      scrollable
      light
      v-model="agreementDialog"
      full-width
      width="600px"
    >
      <v-card color="white">
        <v-card-text class="o-y-hidden pa-1">
        <iframe  class="agreement-details"
        v-if="updatedJforceAgreementContent"
        :src="`data:text/html;charset=utf-8,<div style='font-family:Roboto, sans-serif; padding:10px 0 150px;'> ${encodeURI(updatedJforceAgreementContent)} </div>`">
          </iframe>
        </v-card-text>
        <v-divider></v-divider>

        <v-divider></v-divider>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn
            v-if="updatedJforceAgreement"
            flat
            block
            rel="noreferrer noopener"
            target="_blank"
            :href="updatedJforceAgreementPdf"
            class="mx-auto my-0 primary--text"
          >
            {{ $t("onboarding_terms_and_conditions.download_contract") }}
            <v-icon right dark>file_download</v-icon>
          </v-btn>
          <v-btn
            v-else
            @click="updateUser"
            flat
            block
            class="mx-auto my-0 primary--text"
          >{{ $t("button.accept_and_continue") }}</v-btn>
        </v-card-actions>
        <!-- <v-btn color="green darken-1" flat="flat" @click="dialog = false">Close</v-btn> -->
      </v-card>
    </v-dialog>

    <!-- Refresh app when new version is available -->
    <v-snackbar
      :timeout="timeout"
      v-model="snackbar"
      color="primary"
      right
      auto-height
      :class="{ 'pa-2': isMobile }"
    >
      {{ $t("app.new_service_worker") }}
      <v-btn dark flat @click="refreshApp">{{ $t("button.refresh") }}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { setCookie, getCookie } from '@/util/cookies'
import { scrollToY } from '@/util/scroll'
import { isRTL } from '@/config'
import {
  dashboardOtherItems,
  referralLink
} from '@/modules/dashboard/_config'
export default {
  name: 'App',
  data () {
    return {
      windowX: 0,
      persistent: true,
      agreementDialog: false,
      desktopMinX: 960,
      offsetTop: 0,
      snackbar: false,
      warning: true,
      timeout: 0,
      dialog: false,
      deferredPrompt: null,
      addToHomeScreenDialog: false
    }
  },
  created () {
    window.addEventListener('new-service-worker', e => {
      this.snackbar = true
    })
    window.addEventListener('agreement-updated', e => {
      this.persistent = e.detail.persistent
      if(!this.isImpersonate || e.detail.source == "internal"){
          this.openAgreementDialog()
      }
      
    })
    window.addEventListener('beforeinstallprompt', e => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault()
      // Stash the event so it can be triggered later.
      if (getCookie('add-to-home') !== 'false') this.deferredPrompt = e
    })
    window.addEventListener('cookie-not-found', e => {
      this.goToJumiaCentralAuth();
    })

    // Makes the whole Vue App RTL
    if (isRTL) {
      this.$vuetify.rtl = true
    }
  },
  computed: {
    ...mapGetters({
      pageToolbar: 'app/pageToolbar',
      pageNavigationDrawer: 'app/pageNavigationDrawer',
      pageBottomNavigation: 'app/pageBottomNavigation',
      pageDialog: 'app/pageDialog',
      isDesktop: 'app/isDesktop',
      isMobile: 'app/isMobile',
      loadingPage: 'app/loadingPage',
      showAddToHome: 'user/showAddToHome',
      updatedJforceAgreement: 'user/updatedJforceAgreement',
      updatedJforceAgreementContent: 'user/updatedJforceAgreementContent',
      updatedJforceAgreementPdf: 'user/updatedJforceAgreementPdf',
      status: 'user/status',
      isImpersonate: 'user/isImpersonate',
      isAuth: 'user/isAuth',
      isJForce: 'user/isJForce',
      loginError: 'user/systemError'
    }),
    hasScroll () {
      return window.pageYOffset > 200
    },
    showAgreementInfo(){
      return !this.updatedJforceAgreement && !this.loadingPage && this.isAuth && this.isJForce && this.$route.meta.auth
    },
    showAddToHomeDialog () {
      return this.showAddToHome && this.deferredPrompt && !this.agreementDialog
    },
    isSuspended () {
      return this.status && this.status.label.toLowerCase() == 'suspended'
    }
  },

  components: {
    'app-toolbar': () =>
      import(
        /* webpackChunkName: "AppToolbar" */ '@/components/AppToolbar.vue'
      ),
    'app-navigation-drawer': () =>
      import(
        /* webpackChunkName: "AppNavigationDrawer" */ '@/components/AppNavigationDrawer.vue'
      ),
    'app-bottom-navigation': () =>
      import(
        /* webpackChunkName: "AppBottomNavigation" */ '@/components/AppBottomNavigation.vue'
      ),
    'dashboard-card-static': () =>
      import(
        /* webpackChunkName: "AppRightNavigation" */ '@/modules/dashboard/_components/DashboardCardStatic'
      )
  },
  watch: {
    showAddToHomeDialog: function (val) {
      if (val) this.addToHomeScreenDialog = true
    },
    loginError: function (val) {
      if (val === true) {
        setTimeout(() => {
          this.clearErrors()
        }, 5000)
      }
    }
  },
  methods: {
    ...mapActions({
      setDesktopDevice: 'app/setDesktopDevice',
      setMobileDevice: 'app/setMobileDevice',
      update: 'user/updateUser',
      goToJumiaCentralAuth: 'app/goToJumiaCentralAuth',
      clearErrors: 'user/cleanSystemErrors'
    }),
    acceptTerm(e){
     if(e.srcElement.localName == 'a' && e.srcElement.classList.contains('update-agreement')){
       this.updateUser();
     }
    },
    updateUser () {
      this.update({
          updated_jforce_agreement: true,
          date_of_agreement: new Date().toJSON().slice(0, 19).replace('T', ' ')
        })
        .then(data => {
          this.agreementDialog = false
          this.persistent = true
        })
        .catch(err => {
          console.log(err)
          this.agreementDialog = false
          this.persistent = true
        })
    },
    dashboardOthers () {
      return [...dashboardOtherItems]
    },
    redirectTo (e) {
      if (e.target.matches('.redirect-link')) {
        this.$router.push({ path: 'suspended-info' })
      }
    },
    topFunction () {
      scrollToY(0, 8000, 'easeOutSine')
    },
    onResize () {
      this.windowX = window.innerWidth

      var isDesktop = this.windowX >= this.desktopMinX
      var isMobile = this.windowX < this.desktopMinX

      if (isDesktop && (this.isMobile || (!this.isMobile && !this.isDesktop))) {
        this.setDesktopDevice()
      } else if (
        isMobile &&
        (this.isDesktop || (!this.isMobile && !this.isDesktop))
      ) {
        this.setMobileDevice()
      }
    },
    onScroll () {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    },
    refreshApp () {
      // test service worker
      location.reload()
    },
    openDialog () {
      this.dialog = true
    },
    openAgreementDialog () {
      this.agreementDialog = true
    },
    no () {
      this.addToHomeScreenDialog = false
      setCookie('add-to-home', 'false', 7)
      this.$gtm.buttonClicked('jforce-add-home', 'no')
      this.deferredPrompt = null
    },
    yes () {
      this.$gtm.buttonClicked('jforce-add-home', 'yes')
      this.addToHomeScreenDialog = false

      this.deferredPrompt.prompt()
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          this.$gtm.buttonClicked('google-add-home', 'yes')
        } else {
          this.$gtm.buttonClicked('google-add-home', 'no')
        }
        this.deferredPrompt = null
      })
    }
  }
}
</script>

<style>
.o-y-hidden{
  overflow-y:hidden !important;
}
.agreement-details{
  display: block;
  border: none;
  height: 100vh;
  width: 100%;
}

.v-alert.login-error{
  position: fixed;
  top:0;
  width: 100%;
  z-index: 9;
  min-height: 60px;
}
.btn-close{
  max-width: 40px;
  display: flex;
  cursor: pointer;
}
sticky-alert{
  display: flex;
  position: fixed;
  top: 56px;
  width: 100%;
  background: red;
  color: white;
  padding: 10px;
  z-index: 2;
  align-items: center;
}
.sticky-alert a{
  color: #0051a7;
  font-weight: bold;
}
.sticky-alert .v-icon{
  margin-right: 10px;
}

.sticky-alert .alert-content{
  line-height: 1.3rem;
}

v-btn.text-transform-normal {
  text-transform: inherit;
}
.text-d-none {
  text-decoration: none;
}
.text--orange {
  color: #f07838;
}
.is-homePage .v-navigation-drawer--clipped,
.is-homePage .v-overlay {
  top: 56px;
}
.v-navigation-drawer--clipped .type-list .card-item {
  border-top: 1px #cccccc2b solid;
}
.v-navigation-drawer--clipped .type-list .badge + div {
  display: flex;
  align-items: center;
}
.v-navigation-drawer--clipped .jcard {
  box-shadow: none !important;
}
.w-100 {
  width: 100%;
}
.promotion-banner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-btn--fixed .v-icon{
  height: auto !important;
  width: auto !important;
}
.image-wrapper {
  position: relative;
  padding-bottom: 100%;
}
.image-wrapper img {
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.j-subheading,
.j-subheading-full {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.j-subheading {
  padding: 0 8px 8px 8px;
}

.j-subheading-full {
  padding: 0 16px 8px 16px;
}

@media only screen and (min-width: 959px) {
  .j-subheading,
  .j-subheading-full {
    padding: 0 0 8px 0;
  }
  .sticky-alert{
    top: 64px;
  }
}
@media only screen and (min-width: 695px) and (max-width: 959px){
  .is-homePage .v-navigation-drawer--clipped,
  .is-homePage .v-overlay,
  .sticky-alert{
    top: 48px;
  }
}

.v-alert.v-alert {
  margin-top: 0;
  border-width: 2px 0 0 0;
}
.v-alert.v-alert .v-icon,
.v-alert.v-alert a {
  color: white !important;
}

.router-view {
  width: 480px;
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 16px;
}
.router-view.sr-configs-list {
  background-color: white;
  margin-top: 2px;
  width: auto;
  height: 100%;
  box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.2) !important;
}

.info-title {
  font-size: 19px;
  font-weight: bold;
  color: #898997;
  text-align: center;
}

.info-description {
  font-size: 16px;
  color: #8d8d92;
  text-align: center;
}
.icon-promo {
  max-width: 16px;
  position: absolute;
  right: 0;
  top: -2px;
}

.jcard {
  background-color: white;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
}

@media only screen and (min-width: 960px) {
  .sticky-alert{
    margin-top: 0px;
    padding-right: 0px;
    padding-left: 310px;
    transform: translateY(0px);
  }
  .list__tile__avatar {
    min-width: 48px !important;
  }

  .item .list__tile {
    padding-left: 24px !important;
  }

  .list__tile__action {
    min-width: 40px !important;
  }

  .item .list__tile--active {
    background-color: rgba(240, 120, 56, 0.1);
    border-left: 3px solid;
    padding-left: 21px !important;
  }

  .list .item .list__tile--link:hover {
    background-color: #f5f5f5 !important;
  }
}

.item .list__tile__title {
  font-size: 15px;
  font-weight: 400;
}

.item.mobile .icon {
  color: rgba(0, 0, 0, 0.54);
}

.item.mobile .list__tile--active .icon {
  color: rgba(0, 0, 0, 0.54);
}

.item:not(.mobile) .list__tile--active .list__tile__title {
  font-weight: 500;
}

.item.mobile .list__tile--active.primary--text {
  color: inherit !important;
}

.jcard_dialog--header {
  display: flex;
}

.jcard_dialog--header--title {
  flex-grow: 1;
}

.jcard_dialog--content > .list > div:nth-child(odd) > span {
  font-weight: 500;
}

.jcard_dialog--content > .list > div:nth-child(even) {
  font-size: 13px;
  padding-bottom: 4px;
}

.jcard_dialog--header--description {
  font-size: 16px;
  color: #767676;
}

.jcard_dialog--actions {
  text-align: right;
}

.jcard_dialog--actions_left {
  text-align: left;
}

.pointer {
  cursor: pointer;
}
.promoted .card__widget {
  width: 64px;
}
.bonus-slider .jcard {
  height: 100%;
  box-shadow: 0 0 8px #cccccc;
  border-radius: 4px !important;
}
.bonus-slider.single-swiper .jcard {
  height: 110%;
  border-radius: 0 !important;
}
.referral-link i {
  position: relative;
  top: -5px;
}
</style>
